import React, {useEffect, useRef} from 'react'
import {useParams} from "react-router";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import Loading from "components/Loading";
import MembersList from "./components/MembersList";
import {makeStyles} from "@material-ui/styles";
import {connect} from "react-redux";
import MembersDocumentsList from "./components/MembersDocumentsList";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import DemandValidationMessages from "components/DemandValidationMessages";
import scheduleReloadTimeout from "../../../utils/scheduleReloadTimeout";
import {PurchasingGroupStageSections} from "../../../constants/PurchasingGroupStageSections";
import UserService from "services/UserService";
import {PurchasingGroupRole} from "../../../constants/PurchasingGroupRole";

const useStyle = makeStyles(theme => ({
    root: {
        width: "100%"
    }
}))

function PurchasingGroupStage1Members(
    {
        panelRef,
        validationSection,
        members,
        membersDocs,
        purchasingGroupHeader,
        stageSections
    }) {
    const classes = useStyle();
    const params = useParams();
    const groupId = params.id;
    const stage = params.stage;
    const formId = params.section;
    const timeout = useRef(0);
    const documentsApiPathType = stage === "1" ? "members" : "swz"
    const coordinatorView = purchasingGroupHeader.userRole === PurchasingGroupRole.MEMBER;
    const editable = validationSection.editable;
    useStepperStateCloseValidator(formId);


    const getMembers = () => {
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = 0;
        }
        if (stage === "1")
            PurchasingGroupStage1Service.getMembers(groupId);
        PurchasingGroupStage1Service.getAllMembersDocuments(groupId, documentsApiPathType);

        const mainSection = stageSections[stage === "1" ? PurchasingGroupStageSections.STAGE_1_SECTION : PurchasingGroupStageSections.STAGE_2_SECTION];
        if (mainSection && mainSection.schedule) {
            UserService.serverTime().then(serverTime => {
                let reloadTimeout = scheduleReloadTimeout(mainSection.schedule, serverTime);
                if (reloadTimeout) {
                    timeout.current = setTimeout(() => {
                        getMembers();
                    }, reloadTimeout)
                }
            })
        }
    }

    useEffect(() => {
        getMembers();
        PurchasingGroupSectionService.getSections(groupId, validationSection.section)
        return () => {
            if (timeout.current) {
                clearTimeout(timeout.current);
                timeout.current = 0;
            }
            if (stage === "1")
                PurchasingGroupStage1Service.clearResources(PurchasingGroupStage1Service.PURCHASING_GROUP_MEMBERS_RESOURCE_ID);
            PurchasingGroupStage1Service.clearResources(PurchasingGroupStage1Service.PURCHASING_GROUP_MEMBERS_DOCUMENTS_RESOURCE_ID);
        }
        // eslint-disable-next-line
    }, [groupId])

    if ((stage === "1" && !members) || !membersDocs) return <Loading/>

    return (
        <div className={classes.root}>
            {!coordinatorView && <DemandValidationMessages editable={validationSection.editable} section={validationSection}/>}
            <MembersDocumentsList
                groupId={groupId}
                mainDocs
                editable={editable}
                coordinatorView={coordinatorView}
                membersDocs={membersDocs}
                validationSection={validationSection}
                allMemberDocumentsApiPath={documentsApiPathType}
            />
            {stage === "1" &&
                <MembersList
                    groupId={groupId}
                    members={members}
                    coordinatorView={coordinatorView}
                    editable={editable}
                    validationSection={validationSection}
                />
            }
        </div>
    )
}

PurchasingGroupStage1Members.propTypes = {}

export default connect((state) => ({
    stageSections: state.resources[PurchasingGroupSectionService.PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID],
    members: state.resources[PurchasingGroupStage1Service.PURCHASING_GROUP_MEMBERS_RESOURCE_ID],
    membersDocs: state.resources[PurchasingGroupStage1Service.PURCHASING_GROUP_MEMBERS_DOCUMENTS_RESOURCE_ID],
    purchasingGroupHeader: state.resources[PurchasingGroupStage1Service.PURCHASING_GROUP_HEADER_RESOURCE_ID]
}), {})(PurchasingGroupStage1Members);